module.exports = __webpack_public_path__ + "images/amber_case.png?v=b7af951230237905a75f6324e720d648";